// extracted by mini-css-extract-plugin
export default {"container":"MSIHz","header":"sVtwL","link":"_2ufLq","list":"hM70K"};